import { createContext, useContext } from 'react';

/** Default when no Provider: plain text fields (no LaTeX UI). */
const defaultValue = {
  useLatex: false,
};

export const LatexEditorFormContext = createContext(defaultValue);

export function useLatexEditorForm() {
  return useContext(LatexEditorFormContext);
}
